import React, { VFC } from 'react';
import { Theme, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import ToyononImage from '../../../../images/features/toyono/toyonon.png';
import { TITLE_COLOR } from '~/src/feature/toyono/constants';

const useStyles = makeStyles((theme) => ({
  descriptionText: {
    marginBottom: theme.spacing(3),
    letterSpacing: '1px',
    lineHeight: 1.8,
  },
  characterText: {
    color: TITLE_COLOR,
    fontSize: theme.typography.pxToRem(14),
    textAlign: 'center',
  },
}));

const Container = styled.div<{ theme: Theme }>`
  padding: ${({ theme }) => theme.spacing(4)}px;
  background: #fff;
  margin: auto;
  width: 100%;
  text-align: center;
  display: flex;
  ${({ theme }) => theme.breakpoints.up('md')} {
    text-align: left;
  }
`;

const Description = styled.div<{ theme: Theme }>`
  ${({ theme }) => theme.breakpoints.up('md')} {
    display: flex;
  }
`;

const DescriptionText = styled.div<{ theme: Theme }>`
  text-align: left;
  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 80%;
    margin-right: 3%;
  }
`;

const Title = styled.div<{ theme: Theme }>`
  font-weight: bold;
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  margin-bottom: ${({ theme }) => theme.spacing(3)}px;
  text-align: center;
  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: ${({ theme }) => theme.typography.pxToRem(20)};
    text-align: left;
  }
`;

const TitleBlock = styled.span<{ theme: Theme }>`
  display: block;
  ${({ theme }) => theme.breakpoints.up('md')} {
    display: inline;
  }
`;

const Img = styled.img<{ theme: Theme }>`
  width: 80%;
  max-width: 150px;
  height: auto;
  margin: 0 10% 5%;
  ${({ theme }) => theme.breakpoints.up('md')} {
    margin: 0 10% 10%;
  }
`;

interface Props {}

const Character: VFC<Props> = () => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Container theme={theme}>
      <Description theme={theme}>
        <DescriptionText theme={theme}>
          <Title theme={theme}>
            <TitleBlock theme={theme}>老若男女に愛される、</TitleBlock>
            ゆるキャラ「とよのん」が町をPR！
          </Title>
          <Typography className={classes.descriptionText}>
            自然豊かな豊能町の田園に咲く「たんぽぽ」をモチーフにしたキャラクター。2020年ゆるキャラグランプリでは、第6位の快挙を成し遂げた町の人気者です。
          </Typography>
          <Typography className={classes.descriptionText}>
            町の特売所で開催されるイベントや、町内外のイベントにも積極的に参加して、豊能町の魅力発信とともに、ヤーコンや高山真菜などの野菜やお米といった町特産品のPR活動に励んでいます。是非町内で探してみてね！
          </Typography>
        </DescriptionText>
        <div>
          <Img src={ToyononImage} theme={theme} alt="とよのん" />
          <Typography className={classes.characterText}>
            豊能町イメージキャラクター
          </Typography>
          <Typography className={classes.characterText}>とよのん</Typography>
        </div>
      </Description>
    </Container>
  );
};

export default Character;
